import {Component} from '@angular/core';

@Component({
  selector: 'dialog-add-livetag',
  templateUrl: './dialog-add-livetag.component.html',
})
export class DialogAddLivetagComponent {}
